import { GisEditContext } from "./gis-edit-context";

export class MapUI {
  selectAllButton: HTMLDivElement;
  mergeButton: HTMLDivElement;
  deleteButton: HTMLDivElement;

  drawButton: HTMLDivElement;
  hotDogToolButton: HTMLDivElement;
  cutToolButton: HTMLDivElement;
  rectangleToolButton: HTMLDivElement;
  circleToolButton: HTMLDivElement;
  uploadButton: HTMLDivElement;

  editButtonsGroup: HTMLDivElement;
  sidebarDiv: HTMLDivElement;

  constructor(ctx: GisEditContext) {
    this.selectAllButton = document.createElement("div");
    this.mergeButton = document.createElement("div");
    this.deleteButton = document.createElement("div");

    this.drawButton = document.createElement("div");
    this.hotDogToolButton = document.createElement("div");
    this.rectangleToolButton = document.createElement("div");
    this.circleToolButton = document.createElement("div");
    this.uploadButton = document.createElement("div");
    this.cutToolButton = document.createElement("div");

    this.editButtonsGroup = document.createElement("div");
    this.editButtonsGroup.className =
      "esri-component esri-widget nmcris-esri-button-group-vert";
    this.editButtonsGroup.append(
      this.drawButton,
      this.hotDogToolButton,
      this.rectangleToolButton,
      this.circleToolButton,
      this.uploadButton,
      this.cutToolButton,
    );

    this.sidebarDiv = document.createElement("div");
    this.sidebarDiv.className = "d-flex";
    this.sidebarDiv.style.boxShadow = "0 0"; // un-set the default esri-component box-shadow setting

    // select all
    this.selectAllButton.className =
      "mr-2 esri-icon-checkbox-checked esri-widget--button esri-widget esri-interactive esri-shadow";
    this.selectAllButton.title = `Select All ${ctx.gisType.humanReadable} Shape(s)`;
    this.selectAllButton.setAttribute("role", "button");
    this.sidebarDiv.appendChild(this.selectAllButton);

    // merge shapes
    this.mergeButton.className =
      "mr-2 esri-widget--button esri-widget esri-interactive esri-shadow";
    this.mergeButton.title = `Merge ${ctx.gisType.humanReadable} Shapes`;
    this.mergeButton.setAttribute("role", "button");
    const mergeButtonIcon = document.createElement("calcite-icon");
    mergeButtonIcon.setAttribute("icon", "overlap-features");
    mergeButtonIcon.setAttribute("scale", "s");
    this.mergeButton.appendChild(mergeButtonIcon);
    this.sidebarDiv.appendChild(this.mergeButton);

    // delete button
    this.deleteButton.className =
      "esri-icon-trash text-white esri-widget--button esri-widget esri-interactive esri-shadow";
    this.deleteButton.style.backgroundColor = "lightcoral";
    this.deleteButton.title = `Delete ${ctx.gisType.humanReadable} Shape(s)`;
    this.deleteButton.setAttribute("role", "button");
    this.sidebarDiv.appendChild(this.deleteButton);

    document
      .getElementById("sidebar-buttons")
      ?.replaceChildren(this.sidebarDiv);

    // draw button
    this.drawButton.className =
      "esri-icon-edit esri-widget--button esri-widget esri-interactive";
    this.drawButton.title = `Draw a ${ctx.gisType.humanReadable}`;
    this.drawButton.tabIndex = 0;
    this.drawButton.setAttribute("role", "button");

    // hot dog tool button
    this.hotDogToolButton.className =
      "esri-icon-polyline esri-widget--button esri-widget esri-interactive";
    this.hotDogToolButton.title = `Draw a buffered-line ${ctx.gisType.humanReadable}`;
    this.hotDogToolButton.tabIndex = 0;
    this.hotDogToolButton.setAttribute("role", "button");

    // rectangle tool button
    this.rectangleToolButton.className =
      "esri-icon-sketch-rectangle esri-widget--button esri-widget esri-interactive";
    this.rectangleToolButton.title = `Create a rectangle ${ctx.gisType.humanReadable}`;
    this.rectangleToolButton.tabIndex = 0;
    this.rectangleToolButton.setAttribute("role", "button");

    // circle tool button
    this.circleToolButton.className =
      "esri-icon-dial esri-widget--button esri-widget esri-interactive";
    this.circleToolButton.title = `Create a circle ${ctx.gisType.humanReadable}`;
    this.circleToolButton.tabIndex = 0;
    this.circleToolButton.setAttribute("role", "button");

    // upload button
    this.uploadButton.className =
      "esri-icon-upload esri-widget--button esri-widget esri-interactive";
    this.uploadButton.title = "Upload a Shapefile";
    this.uploadButton.tabIndex = 0;
    this.uploadButton.setAttribute("role", "button");

    // cut tool button
    this.cutToolButton.className =
      "esri-widget--button esri-widget esri-interactive";
    this.cutToolButton.title = `Draw a line along which to cut existing ${ctx.gisType.humanReadable} shapes`;
    this.cutToolButton.tabIndex = 0;
    this.cutToolButton.setAttribute("role", "button");
    const cutToolButtonIcon = document.createElement("calcite-icon");
    cutToolButtonIcon.setAttribute("icon", "split-geometry");
    cutToolButtonIcon.setAttribute("scale", "s");
    this.cutToolButton.appendChild(cutToolButtonIcon);
  }

  enableAll() {
    for (let n = 0; n < this.editButtonsGroup.children.length; n++) {
      this.editButtonsGroup.children.item(n)?.removeAttribute("disabled");
    }
    for (let n = 0; n < this.sidebarDiv.children.length; n++) {
      this.sidebarDiv.children.item(n)?.removeAttribute("disabled");
    }
  }

  disableAll() {
    for (let n = 0; n < this.editButtonsGroup.children.length; n++) {
      this.editButtonsGroup.children.item(n)?.setAttribute("disabled", "");
    }
    for (let n = 0; n < this.sidebarDiv.children.length; n++) {
      this.sidebarDiv.children.item(n)?.setAttribute("disabled", "");
    }
  }
}
